import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemRoutingModule } from './system-routing.module';
import { SystemComponent } from './system.component';
import { TabViewModule } from 'primeng/tabview';
import { QdsTabbar, QdsDivider } from '@quartzds/core-angular';

@NgModule({
  imports: [
    CommonModule,
    SystemRoutingModule,
    TabViewModule,
    QdsTabbar,
    QdsDivider
  ],
  declarations: [SystemComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  
})
export class SystemModule {}
